export function relativeTime(iso: string | Date | null | undefined): string {
    if (iso == null || iso === '') return '';
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return '';
    const now = Date.now();
    // Server slightly ahead of client (or TZ quirks) reads as "now"; avoid bogus "1s ago"
    if (then > now) {
        try {
            return new Date(iso).toLocaleString(navigator.language, {
                dateStyle: 'medium',
                timeStyle: 'short',
            });
        } catch {
            return typeof iso === 'string' ? iso : '';
        }
    }
    const diff = now - then;
    const mins = Math.floor(diff / 60000);
    // Smallest unit is minutes (sub-minute counts as 1m ago).
    if (mins < 1) return '1m ago';
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(diff / 3600000);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(diff / 86400000);
    if (days >= 1 && days <= 7) {
        return days === 1 ? '1 day ago' : `${days} days ago`;
    }
    try {
        return new Date(iso).toLocaleDateString(navigator.language, { dateStyle: 'medium' });
    } catch {
        return typeof iso === 'string' ? iso : '';
    }
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
    const start = (page - 1) * pageSize;
    return items.slice(start, start + pageSize);
}

export function matchesSearch(haystack: string, needle: string): boolean {
    if (!needle) return true;
    return (haystack || '').toLowerCase().includes(needle.toLowerCase());
}
